import { useRouter } from 'next/router';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import {
  Select, MenuItem, FormControl, InputLabel,
} from '@mui/material';

interface Props {
  selected?: any;
}

type Statuses = 'public' | 'private' | 'all';

export const VisibilityFilter = ({ selected }: Props) => {
  const router = useRouter();

  const defaultValue = 'public';

  const statusOptions = {
    public: 'Public',
    private: 'Private',
    all: 'All',
  };

  const allTypes = Object.keys(statusOptions);

  const onChange = (n: string) => {
    if (n === '' || n === defaultValue) {
      updateRouterQuery(router, { visibility: [] });
      return;
    }

    updateRouterQuery(router, { visibility: n });
  };

  const onClose = (): void => {
    setTimeout(() => {
      (document?.activeElement as HTMLInputElement)?.blur();
    }, 0);
  };

  return (
    <FormControl className="w-full" size="small">
      <InputLabel id="statusLabel">Visibility</InputLabel>
      <Select
        className="w-full"
        label="visibility"
        labelId="visibilityLabel"
        id="visibility"
        onClose={onClose}
        onChange={(e) => onChange(e.target.value as string)}
        value={selected || defaultValue}
      >
        {allTypes.map(
          (key: string) => (
            <MenuItem key={key} value={key}>
              {statusOptions[key as Statuses]}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};
